import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="mx-auto flex w-full max-w-7xl flex-1 flex-col items-center justify-center px-4 py-24 text-center md:px-6">
        <span className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-primary-100 text-primary-600">
          <i className="ri-compasses-2-line w-7 h-7 flex items-center justify-center"></i>
        </span>
        <h1 className="mt-5 font-heading text-2xl md:text-3xl font-bold text-foreground-950">这个页面走丢了</h1>
        <p className="mt-3 text-sm text-foreground-500 font-mono">{location.pathname}</p>
        <p className="mt-3 max-w-md text-sm text-foreground-600">
          页面可能已调整或链接有误，返回首页即可继续浏览实拍、第一现场、完整版、录像、路透与分直拍内容。
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 cursor-pointer transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-line w-4 h-4 flex items-center justify-center"></i>
          返回首页
        </Link>
      </main>
      <SiteFooter />
    </div>
  );
}